import {
  Box,
  HStack,
  VStack,
  Button,
  Link,
  Heading,
  FormControl,
  Input,
  Text,
  Center,
  Image,
  Divider,
  Modal,
  useToast,
} from "native-base";
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faGoogle } from "@fortawesome/free-brands-svg-icons";
import { useNavigate } from "react-router-dom";
import Logo from "../../Assets/img/logo_Ys_with_blue.jpeg";
import ToastService from "../shared/ToastService";
import Cookies from 'js-cookie';
const Login = ({ callAppFunction }) => {
  const navigate = useNavigate();
  const toast = useToast();
  const [modalVisible, setModalVisible] = useState(false);
  const [email, setemail] = useState("faieemk444@gmail.com");
  const [password, setPassword] = useState("1234");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [touched, setTouched] = useState({
    email: false,
    password: false,
  });
  const handleLogin = () => {
    if (!email || !password) {
      setError("All fields are required.");
      toast.show({
        render: ({ id }) => (
          <ToastService
            id={id}
            title={"All fields are required."}
            variant={"top-accent"}
            status={"error"}
          />
        ),
        placement: "top-right",
      });
      return; // Exit the function if fields are empty
    }
    fetch("./user.json")
      .then((response) => response.json())
      .then((data) => {
        const validUser = data.users.find(
          (user) => user.personal_information.email === email && user.personal_information.password === password
        );
        if (validUser) {
          Cookies.set("userSession", validUser.id);
          setIsLoading(true);
          callAppFunction();
          toast.show({
            render: ({ id }) => (
              <ToastService
                id={id}
                title={"Success"}
                variant={"top-accent"}
                status={"success"}
                description={"Login Successful"}
              />
            ),
            placement: "top-right",
          });
        } else {
          setError("Invalid email or password.");
          setIsLoading(false);
          toast.show({
            render: ({ id }) => (
              <ToastService
                id={id}
                title={"Invalid email or password."}
                variant={"top-accent"}
                status={"error"}
              />
            ),
            placement: "top-right",
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
        setError("Error fetching users.");
        setIsLoading(false);
        toast.show({
          render: ({ id }) => (
            <ToastService
              id={id}
              title={"Error"}
              variant={"top-accent"}
              status={"error"}
              description={"Error fetching users."}
            />
          ),
          placement: "top-right",
        });
      });
  };
  

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  // Function to update screen width and height on resize
  const updateScreenSize = () => {
    setScreenWidth(window.innerWidth);
    setScreenHeight(window.innerHeight);
  };

  // Add event listener when component mounts
  useEffect(() => {
    window.addEventListener("resize", updateScreenSize);
    return () => {
      // Clean up event listener when component unmounts
      window.removeEventListener("resize", updateScreenSize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.innerWidth]);

  const handleBlur = (field) => {
    setTouched((prevState) => ({ ...prevState, [field]: true }));
  };

  const showError = (field) => {
    if (touched[field] && !eval(field) && field === "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        return <Text color="red.500">Invalid email address.</Text>;
      }
    } else {
      return (
        touched[field] &&
        !eval(field) && <Text color="red.500">This field is required.</Text>
      );
    }
  };

  return (
    <>
      <Box
        backgroundColor={"info.100"}
        _dark={{ bg: "coolGray.800" }}
        _text={{
          fontSize: "md",
          fontWeight: "medium",
          color: "warmGray.50",
          textAlign: "center",
        }}
        minHeight={"100vh"}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Box
          display={screenWidth <= 1230 ? "none" : "flex"}
          alignSelf={"start"}
          maxW={"100%"}
          bg="indigo.300"
          _dark={{
            bg: "indigo.200",
          }}
          w={"750"}
          h={"90vh"}
          position={"absolute"}
          rounded="sm"
          _text={{
            color: "warmGray.50",
            fontWeight: "medium",
          }}
          shadow={"3"}
        >
          <Heading
            ml={46}
            _dark={{
              color: "indigo.400",
            }}
            color={"blue.900"}
            mt={"30vh"}
          >
            Your Saving
          </Heading>
          <Text
            _dark={{
              color: "indigo.400",
            }}
            color={"indigo.900"}
            fontWeight={"bold"}
            ml={46}
          >
            Spends Analysis and Finance Management Application
          </Text>
          <Divider
            mt={6}
            my="2"
            _light={{
              bg: "muted.800",
            }}
            _dark={{
              bg: "muted.50",
            }}
          />
          <Text
            _dark={{
              color: "indigo.400",
            }}
            color={"indigo.900"}
            fontWeight={"bold"}
            ml={46}
            mt={3}
          >
            Use Social Media
          </Text>
          <HStack space={3} mt="5" ml={46}>
            <Button
              backgroundColor={"white"}
              _text={{
                color: "black",
                fontWeight: "medium",
              }}
              onPress={() => console.log("hello world")}
              leftIcon={<FontAwesomeIcon color="red" icon={faGoogle} />}
            >
              Sign In With Google
            </Button>
            <Button
              backgroundColor={"white"}
              _text={{
                color: "black",
                fontWeight: "medium",
              }}
              onPress={() => console.log("hello world")}
              leftIcon={<FontAwesomeIcon color="blue" icon={faFacebook} />}
            >
              Sign In With Facebook
            </Button>
          </HStack>
        </Box>
        <Box
          rounded="lg"
          overflow="hidden"
          borderColor="coolGray.200"
          borderWidth="1"
          _dark={{
            borderColor: "coolGray.600",
            backgroundColor: "gray.700",
          }}
          _web={{
            shadow: 2,
            borderWidth: 0,
          }}
          _light={{
            backgroundColor: "gray.50",
          }}
          safeArea
          p="2"
          py="8"
          w="90%"
          maxW="420"
        >
          <Center>
            <Image
              size={150}
              alt="fallback text"
              borderRadius={10}
              source={{
                uri: Logo,
              }}
              fallbackSource={{
                uri: "https://www.w3schools.com/css/img_lights.jpg",
              }}
              shadow={5}
            />
            <Heading
              display={screenWidth <= 1230 ? "flex" : "none"}
              _dark={{
                color: "indigo.400",
              }}
              color={"indigo.900"}
            >
              Your Saving
            </Heading>
            <Text
              display={screenWidth <= 1230 ? "flex" : "none"}
              _dark={{
                color: "indigo.400",
              }}
              color={"indigo.900"}
              fontWeight={"bold"}
            >
              Spends Analysis and Finance Management Application
            </Text>
          </Center>
          <Heading
            display={screenWidth <= 1230 ? "none" : "flex"}
            size="lg"
            fontWeight="600"
            color="coolGray.800"
            _dark={{
              color: "warmGray.50",
            }}
          >
            Welcome
          </Heading>
          <Heading
            mt="1"
            _dark={{
              color: "warmGray.200",
            }}
            color="coolGray.600"
            fontWeight="medium"
            size="xs"
          >
            Sign in to continue!
          </Heading>

          <VStack space={3} mt="5">
            <FormControl>
              <FormControl.Label>Email ID</FormControl.Label>
              <Input
                value={email}
                onChangeText={(value) => setemail(value)}
                onBlur={() => handleBlur("email")}
                _dark={{
                  borderColor: "light.100",
                }}
                borderColor={
                  !email && touched.email ? "red.500" : "coolGray.200"
                }
              />
              {showError("email")}
            </FormControl>
            <FormControl>
              <FormControl.Label>Password</FormControl.Label>
              <Input
                value={password}
                onChangeText={(value) => setPassword(value)}
                onBlur={() => handleBlur("password")}
                _dark={{
                  borderColor: "light.100",
                }}
                borderColor={
                  !password && touched.password ? "red.500" : "coolGray.200"
                }
                type="password"
              />
              {showError("password")}
              <Link
                _text={{
                  fontSize: "xs",
                  fontWeight: "500",
                  color: "indigo.500",
                }}
                alignSelf="flex-end"
                mt="1"
                onPress={() => {
                  setModalVisible(!modalVisible);
                }}
              >
                Forget Password?
              </Link>
            </FormControl>
            <Button
              onPress={handleLogin}
              mt="2"
              isLoading={isLoading}
              isLoadingText="Submitting"
              colorScheme="indigo"
            >
              Sign in
            </Button>
            <HStack mt="6" justifyContent="center">
              <Text
                fontSize="sm"
                color="coolGray.600"
                _dark={{
                  color: "warmGray.200",
                }}
              >
                I'm a new user.{" "}
              </Text>
              <Link
                _text={{
                  color: "indigo.500",
                  fontWeight: "medium",
                  fontSize: "sm",
                }}
                onPress={() => navigate("/signup")}
              >
                Sign Up
              </Link>
            </HStack>
          </VStack>
          <Center display={screenWidth <= 1230 ? "flex" : "none"}>
            <Divider
              mt={2}
              my="2"
              _light={{
                bg: "muted.800",
              }}
              _dark={{
                bg: "muted.50",
              }}
            />
            <Text
              _dark={{
                color: "white",
              }}
              color={"indigo.900"}
              fontWeight={"bold"}
              mb={2}
            >
              Want to Login With
            </Text>
            <HStack space={3}>
              <Button
                shadow={5}
                backgroundColor={"light.100"}
                _text={{
                  color: "black",
                  fontWeight: "medium",
                }}
                onPress={() => console.log("hello world")}
                leftIcon={<FontAwesomeIcon color="red" icon={faGoogle} />}
              >
                Google
              </Button>
              <Button
                shadow={5}
                backgroundColor={"light.100"}
                _text={{
                  color: "black",
                  fontWeight: "medium",
                }}
                onPress={() => console.log("hello world")}
                leftIcon={<FontAwesomeIcon color="blue" icon={faFacebook} />}
              >
                Facebook
              </Button>
            </HStack>
          </Center>
        </Box>
      </Box>

      <Modal
        isOpen={modalVisible}
        onClose={() => setModalVisible(false)}
        avoidKeyboard
        size="lg"
      >
        <Modal.Content>
          <Modal.CloseButton />
          <Modal.Header>Forgot Password?</Modal.Header>
          <Modal.Body>
            Enter email address and we'll send a link to reset your password.
            <FormControl mt="3">
              <FormControl.Label>Email</FormControl.Label>
              <Input />
            </FormControl>
          </Modal.Body>
          <Modal.Footer>
            <Button
              flex="1"
              onPress={() => {
                setModalVisible(false);
              }}
            >
              Proceed
            </Button>
          </Modal.Footer>
        </Modal.Content>
      </Modal>
    </>
  );
};

export default Login;
